var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { toSpecialFixed } from '@/lib/utils';
import { getEthAmount } from '../SingleAssetHeader';
import { networkNames } from '@shared/types/executor';
import { ChainId } from '@shared/utils/config/networks';
export var confirmationString = function (fromAssets, toAssets, amount) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    amount = typeof amount === 'string' ? parseFloat(amount) : amount;
    if ((fromAssets === null || fromAssets === void 0 ? void 0 : fromAssets.length) == 1 && (toAssets === null || toAssets === void 0 ? void 0 : toAssets.length) == 1) {
        return "You are about to swap  ".concat(toSpecialFixed(getEthAmount(fromAssets === null || fromAssets === void 0 ? void 0 : fromAssets[0])).value, " ").concat((_a = fromAssets === null || fromAssets === void 0 ? void 0 : fromAssets[0]) === null || _a === void 0 ? void 0 : _a.contract_ticker_symbol, " (").concat((_c = (_b = fromAssets === null || fromAssets === void 0 ? void 0 : fromAssets[0]) === null || _b === void 0 ? void 0 : _b.amountToUse) === null || _c === void 0 ? void 0 : _c.toFixed(2), " USD) to ").concat((_d = toAssets === null || toAssets === void 0 ? void 0 : toAssets[0]) === null || _d === void 0 ? void 0 : _d.contract_ticker_symbol);
    }
    if ((fromAssets === null || fromAssets === void 0 ? void 0 : fromAssets.length) > 1 && (toAssets === null || toAssets === void 0 ? void 0 : toAssets.length) == 1) {
        var string_1 = 'You are about to swap ';
        fromAssets === null || fromAssets === void 0 ? void 0 : fromAssets.forEach(function (assetItem, index) {
            var _a, _b;
            string_1 += "".concat((_a = toSpecialFixed(getEthAmount(assetItem))) === null || _a === void 0 ? void 0 : _a.value, " ").concat(assetItem.contract_ticker_symbol, " (").concat((_b = assetItem.amountToUse) === null || _b === void 0 ? void 0 : _b.toFixed(2), " USD) ");
            if (index !== fromAssets.length - 1) {
                string_1 += 'and ';
            }
        });
        return (string_1 += "to ".concat((_e = toAssets === null || toAssets === void 0 ? void 0 : toAssets[0]) === null || _e === void 0 ? void 0 : _e.contract_ticker_symbol));
    }
    if ((fromAssets === null || fromAssets === void 0 ? void 0 : fromAssets.length) == 1 && (toAssets === null || toAssets === void 0 ? void 0 : toAssets.length) > 1) {
        var string_2 = "You are about to swap  ".concat((_f = getEthAmount(fromAssets[0])) === null || _f === void 0 ? void 0 : _f.toFixed(4), " ").concat((_g = fromAssets === null || fromAssets === void 0 ? void 0 : fromAssets[0]) === null || _g === void 0 ? void 0 : _g.contract_ticker_symbol, " (").concat((_h = fromAssets[0].amountToUse) === null || _h === void 0 ? void 0 : _h.toFixed(2), " USD) for ").concat(toAssets === null || toAssets === void 0 ? void 0 : toAssets.length, " tokens, split into a ratio of ");
        toAssets === null || toAssets === void 0 ? void 0 : toAssets.forEach(function (assetItem, index) {
            var _a, _b;
            string_2 += "".concat((_a = toSpecialFixed(assetItem.percentage, 2)) === null || _a === void 0 ? void 0 : _a.value, "% ").concat(assetItem.contract_ticker_symbol, " (~").concat((_b = ((assetItem.percentage / 100) * amount)) === null || _b === void 0 ? void 0 : _b.toFixed(2), " USD) ");
            if (index !== toAssets.length - 1) {
                string_2 += 'and ';
            }
        });
        return string_2;
    }
    if ((fromAssets === null || fromAssets === void 0 ? void 0 : fromAssets.length) > 1 && (toAssets === null || toAssets === void 0 ? void 0 : toAssets.length) > 1) {
        var string_3 = 'You are about to swap ';
        fromAssets === null || fromAssets === void 0 ? void 0 : fromAssets.forEach(function (assetItem, index) {
            var _a, _b;
            string_3 += "".concat((_a = getEthAmount(assetItem)) === null || _a === void 0 ? void 0 : _a.toFixed(4), " ").concat(assetItem.contract_ticker_symbol, " (").concat((_b = assetItem.amountToUse) === null || _b === void 0 ? void 0 : _b.toFixed(2), " USD) ");
            if (index !== fromAssets.length - 1) {
                string_3 += 'and ';
            }
        });
        string_3 += "for ".concat(toAssets === null || toAssets === void 0 ? void 0 : toAssets.length, " tokens, split into a ratio of ");
        toAssets === null || toAssets === void 0 ? void 0 : toAssets.forEach(function (assetItem, index) {
            var _a, _b;
            string_3 += "".concat((_a = toSpecialFixed(assetItem.percentage, 2)) === null || _a === void 0 ? void 0 : _a.value, "% ").concat(assetItem.contract_ticker_symbol, " (~").concat((_b = ((assetItem.percentage / 100) * amount)) === null || _b === void 0 ? void 0 : _b.toFixed(2), " USD) ");
            if (index !== toAssets.length - 1) {
                string_3 += 'and ';
            }
        });
        return string_3;
    }
    return '';
};
var truncateError = function (error) {
    if (error.length > 100) {
        return error.slice(0, 100) + '...';
    }
    else {
        return error;
    }
};
export var quoteString = function (quoteData, priceData) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
    if (!quoteData || !(priceData === null || priceData === void 0 ? void 0 : priceData.length)) {
        return null;
    }
    try {
        var quote = quoteData.quote, error = quoteData.error;
        //DLN
        if ((_a = quote === null || quote === void 0 ? void 0 : quote.results) === null || _a === void 0 ? void 0 : _a.length) {
            //
            if ((quote === null || quote === void 0 ? void 0 : quote.status) != 'success') {
                console.log('DLN quote error 1', quote.error);
                return {
                    message: 'Error fetching quote. Please try adjusting your slippage or asset amounts',
                };
            }
            var quotes = quote === null || quote === void 0 ? void 0 : quote.results.map(function (x) { return x === null || x === void 0 ? void 0 : x.quote; });
            var transactions = (_b = quote === null || quote === void 0 ? void 0 : quote.results) === null || _b === void 0 ? void 0 : _b.map(function (x) { return x === null || x === void 0 ? void 0 : x.transactions; });
            if (!(quotes === null || quotes === void 0 ? void 0 : quotes.length)) {
                console.log('DLN svm quote error 2', quote);
                return {
                    message: 'Error fetching quote. Please try adjusting your slippage or asset amounts ',
                };
            }
            if (transactions.some(function (x) { var _a, _b, _c; return ((_a = x === null || x === void 0 ? void 0 : x.swap) === null || _a === void 0 ? void 0 : _a.error) || ((_b = x === null || x === void 0 ? void 0 : x.allowance) === null || _b === void 0 ? void 0 : _b.some(function (y) { return y === null || y === void 0 ? void 0 : y.error; })) || ((_c = x === null || x === void 0 ? void 0 : x.sponsor) === null || _c === void 0 ? void 0 : _c.error); })) {
                console.log('DLN evm quote error 3', transactions);
                return {
                    message: 'Error fetching quote. Please try adjusting your slippage or asset amounts ',
                };
            }
            var tokenOutAmounts = quotes.map(function (x) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
                if (x.aggregator != 'DeBridge') {
                    //normal aggregator
                    var result_1 = x;
                    var price = priceData.find(function (x) { var _a, _b, _c; return ((_a = x === null || x === void 0 ? void 0 : x.token) === null || _a === void 0 ? void 0 : _a.address) === ((_b = result_1 === null || result_1 === void 0 ? void 0 : result_1.quote) === null || _b === void 0 ? void 0 : _b.tokenOut) || ((_c = result_1 === null || result_1 === void 0 ? void 0 : result_1.quote) === null || _c === void 0 ? void 0 : _c.outputMint); }) || (priceData === null || priceData === void 0 ? void 0 : priceData[0]);
                    var decimals = (_a = price === null || price === void 0 ? void 0 : price.token) === null || _a === void 0 ? void 0 : _a.decimals;
                    var usdPrice = parseFloat((_c = (_b = price === null || price === void 0 ? void 0 : price.prices) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.priceUsd);
                    var formattedAmount = parseFloat((_d = result_1 === null || result_1 === void 0 ? void 0 : result_1.price) === null || _d === void 0 ? void 0 : _d.amountOut) / Math.pow(10, decimals);
                    var usdValue = formattedAmount * usdPrice;
                    var symbol = (_e = price === null || price === void 0 ? void 0 : price.token) === null || _e === void 0 ? void 0 : _e.symbol;
                    var geniusFee = parseFloat(result_1 === null || result_1 === void 0 ? void 0 : result_1.serviceFeeAmount) / 1000000;
                    return {
                        address: (_f = result_1 === null || result_1 === void 0 ? void 0 : result_1.quote) === null || _f === void 0 ? void 0 : _f.tokenOut,
                        amount: (_g = result_1 === null || result_1 === void 0 ? void 0 : result_1.price) === null || _g === void 0 ? void 0 : _g.amountOut,
                        network: (_h = result_1 === null || result_1 === void 0 ? void 0 : result_1.price) === null || _h === void 0 ? void 0 : _h.network,
                        aggregator: result_1 === null || result_1 === void 0 ? void 0 : result_1.aggregator,
                        usdValue: usdValue,
                        formattedAmount: formattedAmount,
                        usdPrice: usdPrice,
                        decimals: decimals,
                        symbol: symbol,
                        geniusFee: geniusFee,
                    };
                }
                else {
                    var dstChainTokenOut = (_k = (_j = x === null || x === void 0 ? void 0 : x.response) === null || _j === void 0 ? void 0 : _j.estimation) === null || _k === void 0 ? void 0 : _k.dstChainTokenOut;
                    var formattedAmount = parseFloat(dstChainTokenOut.amount) / Math.pow(10, dstChainTokenOut.decimals);
                    return {
                        address: dstChainTokenOut === null || dstChainTokenOut === void 0 ? void 0 : dstChainTokenOut.address,
                        amount: dstChainTokenOut === null || dstChainTokenOut === void 0 ? void 0 : dstChainTokenOut.amount,
                        network: networkNames[dstChainTokenOut === null || dstChainTokenOut === void 0 ? void 0 : dstChainTokenOut.chainId],
                        usdValue: dstChainTokenOut === null || dstChainTokenOut === void 0 ? void 0 : dstChainTokenOut.approximateUsdValue,
                        formattedAmount: formattedAmount,
                        usdPrice: (dstChainTokenOut === null || dstChainTokenOut === void 0 ? void 0 : dstChainTokenOut.approximateUsdValue) / formattedAmount,
                        decimals: dstChainTokenOut === null || dstChainTokenOut === void 0 ? void 0 : dstChainTokenOut.decimals,
                        symbol: dstChainTokenOut === null || dstChainTokenOut === void 0 ? void 0 : dstChainTokenOut.symbol,
                        geniusFee: 0,
                        aggregator: 'DeBridge',
                    };
                }
            });
            //merge tokenOutAmounts with the same address
            var mergedTokenOutAmounts_1 = [];
            tokenOutAmounts.forEach(function (x) {
                var existingToken = mergedTokenOutAmounts_1.find(function (y) { return y.address === x.address; });
                if (existingToken) {
                    existingToken.amount = parseFloat(existingToken.amount) + parseFloat(x.amount);
                    existingToken.formattedAmount = existingToken.formattedAmount + x.formattedAmount;
                    existingToken.usdValue = existingToken.usdValue + x.usdValue;
                }
                else {
                    mergedTokenOutAmounts_1.push(x);
                }
            });
            return mergedTokenOutAmounts_1;
        }
        //ODOS Single Chain
        if ((_c = quote === null || quote === void 0 ? void 0 : quote.result) === null || _c === void 0 ? void 0 : _c.tokensIn) {
            var result_2 = quote === null || quote === void 0 ? void 0 : quote.result;
            var price = priceData.find(function (x) { var _a, _b; return ((_a = x === null || x === void 0 ? void 0 : x.token) === null || _a === void 0 ? void 0 : _a.address) === (result_2 === null || result_2 === void 0 ? void 0 : result_2.tokenOut) || ((_b = result_2 === null || result_2 === void 0 ? void 0 : result_2.tokensOut) === null || _b === void 0 ? void 0 : _b[0]); });
            if (Array.isArray(price)) {
                price = price[0];
            }
            console.log('pricess', price, priceData, quote);
            var decimals = price.token.decimals;
            var usdPrice = parseFloat((_e = (_d = price === null || price === void 0 ? void 0 : price.prices) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.priceUsd);
            var formattedAmount = parseFloat(result_2.amountOut) / Math.pow(10, decimals);
            var usdValue = formattedAmount * usdPrice;
            var symbol = (_f = price === null || price === void 0 ? void 0 : price.token) === null || _f === void 0 ? void 0 : _f.symbol;
            var geniusFee = parseFloat(result_2 === null || result_2 === void 0 ? void 0 : result_2.serviceFeeAmount) / 1000000;
            return [
                {
                    address: result_2.tokenOut,
                    amount: result_2.amountOut,
                    network: result_2.network,
                    aggregator: (_g = result_2.tokenInPrices) === null || _g === void 0 ? void 0 : _g[0].aggregator,
                    usdValue: usdValue,
                    formattedAmount: formattedAmount,
                    usdPrice: usdPrice,
                    decimals: decimals,
                    symbol: symbol,
                    geniusFee: geniusFee,
                },
            ];
        }
        //OTHER Single Chain
        else {
            var result_3 = quote === null || quote === void 0 ? void 0 : quote.result;
            var hasError = ((_j = (_h = quote === null || quote === void 0 ? void 0 : quote.transactionData) === null || _h === void 0 ? void 0 : _h.allowance) === null || _j === void 0 ? void 0 : _j.some(function (x) { return x === null || x === void 0 ? void 0 : x.error; })) ||
                ((_l = (_k = quote === null || quote === void 0 ? void 0 : quote.transactionData) === null || _k === void 0 ? void 0 : _k.swap) === null || _l === void 0 ? void 0 : _l.error) ||
                ((_o = (_m = quote === null || quote === void 0 ? void 0 : quote.transactionData) === null || _m === void 0 ? void 0 : _m.sponsor) === null || _o === void 0 ? void 0 : _o.error);
            if (hasError) {
                console.log('quoteStringError 6', result_3);
                return {
                    message: 'Error fetching quote. Please try adjusting your slippage or asset amounts',
                };
            }
            var price = priceData.find(function (x) { var _a, _b, _c; return ((_a = x === null || x === void 0 ? void 0 : x.token) === null || _a === void 0 ? void 0 : _a.address) === ((_b = result_3 === null || result_3 === void 0 ? void 0 : result_3.quote) === null || _b === void 0 ? void 0 : _b.tokenOut) || ((_c = result_3 === null || result_3 === void 0 ? void 0 : result_3.quote) === null || _c === void 0 ? void 0 : _c.outputMint); }) || (priceData === null || priceData === void 0 ? void 0 : priceData[0]);
            // console.log('price', price, priceData);
            var decimals = (_p = price === null || price === void 0 ? void 0 : price.token) === null || _p === void 0 ? void 0 : _p.decimals;
            var usdPrice = parseFloat((_r = (_q = price === null || price === void 0 ? void 0 : price.prices) === null || _q === void 0 ? void 0 : _q[0]) === null || _r === void 0 ? void 0 : _r.priceUsd);
            var formattedAmount = parseFloat(result_3.price.amountOut) / Math.pow(10, decimals);
            var usdValue = formattedAmount * usdPrice;
            var symbol = (_s = price === null || price === void 0 ? void 0 : price.token) === null || _s === void 0 ? void 0 : _s.symbol;
            var geniusFee = parseFloat(result_3 === null || result_3 === void 0 ? void 0 : result_3.serviceFeeAmount) / 1000000;
            return [
                {
                    address: result_3.quote.tokenOut,
                    amount: result_3.price.amountOut,
                    network: result_3.price.network,
                    aggregator: result_3.aggregator,
                    usdValue: usdValue,
                    formattedAmount: formattedAmount,
                    usdPrice: usdPrice,
                    decimals: decimals,
                    symbol: symbol,
                    geniusFee: geniusFee,
                },
            ];
        }
    }
    catch (e) {
        // console.log('quoteStringError 6', e);
        return {
            message: 'Error fetching quote. Please try adjusting your slippage or asset amounts',
        };
    }
};
export var validate = function (fromAssets, toAssets) {
    var inputNetworks = fromAssets === null || fromAssets === void 0 ? void 0 : fromAssets.map(function (x) { return x.network; });
    var outputNetworks = toAssets === null || toAssets === void 0 ? void 0 : toAssets.map(function (x) { return x.network; });
    var uniqueNetworks = __spreadArray(__spreadArray([], inputNetworks, true), outputNetworks, true).filter(function (x, i, a) { return a.indexOf(x) === i; });
    var totalUsdValue = fromAssets === null || fromAssets === void 0 ? void 0 : fromAssets.reduce(function (acc, asset) { return acc + (asset === null || asset === void 0 ? void 0 : asset.amountToUse); }, 0);
    if (fromAssets === null || fromAssets === void 0 ? void 0 : fromAssets.some(function (asset) { return toAssets.some(function (x) { return x.contract_address === asset.contract_address; }); })) {
        return {
            valid: false,
            error: 'The same asset cannot be swapped for itself',
        };
    }
    if (fromAssets === null || fromAssets === void 0 ? void 0 : fromAssets.some(function (asset) { return !asset.amountToUse || asset.amountToUse === '0'; })) {
        return {
            valid: false,
            error: 'Please enter an amount to swap',
        };
    }
    if ((uniqueNetworks === null || uniqueNetworks === void 0 ? void 0 : uniqueNetworks.length) > 1 && totalUsdValue < 75) {
        if ((inputNetworks === null || inputNetworks === void 0 ? void 0 : inputNetworks.includes(ChainId.ETHEREUM)) || (outputNetworks === null || outputNetworks === void 0 ? void 0 : outputNetworks.includes(ChainId.ETHEREUM))) {
            if (totalUsdValue < 75) {
                return {
                    valid: false,
                    error: 'Order value must be at least $75 for cross-chain swaps using Ethereum',
                };
            }
        }
        else {
            if (totalUsdValue < 5) {
                return {
                    valid: false,
                    error: 'Order value must be at least $5 for cross-chain swaps.',
                };
            }
        }
    }
    if ((inputNetworks === null || inputNetworks === void 0 ? void 0 : inputNetworks.includes(ChainId.ETHEREUM)) && totalUsdValue < 25) {
        return {
            valid: false,
            error: 'Order value must be at least $25 on Ethereum due to gas prices.',
        };
    }
    if ((fromAssets === null || fromAssets === void 0 ? void 0 : fromAssets.length) === 0) {
        return {
            valid: false,
            error: 'Swap',
        };
    }
    if ((toAssets === null || toAssets === void 0 ? void 0 : toAssets.length) === 0) {
        return {
            valid: false,
            error: 'Swap',
        };
    }
    //if all from assets are 0
    if (fromAssets === null || fromAssets === void 0 ? void 0 : fromAssets.every(function (asset) { return asset.amountToUse === 0; })) {
        return {
            valid: false,
            error: 'Swap',
        };
    }
    //if amount to use in fromasset is greater than balance
    if (fromAssets === null || fromAssets === void 0 ? void 0 : fromAssets.some(function (asset) { return asset.amountToUse > asset.usd_value; })) {
        return {
            valid: false,
            error: 'Swap',
        };
    }
    //if from asset contract address included 0xeee amountToUse has to be less to have atleast 0.001
    var cutoff;
    var tokenName;
    console.log('fromAssetspains', fromAssets);
    if (fromAssets === null || fromAssets === void 0 ? void 0 : fromAssets.some(function (asset) {
        var _a;
        if (((_a = asset.contract_address) === null || _a === void 0 ? void 0 : _a.includes('0xeeee')) ||
            ((asset === null || asset === void 0 ? void 0 : asset.contract_address) == 'So11111111111111111111111111111111111111112' &&
                asset.contract_name == 'Solana')) {
            console.log('error from asset -------->', asset);
            var calculatedAmount = asset.usd_value - asset.amountToUse;
            console.log('calculatedAmount -------->', calculatedAmount);
            if (asset.network === ChainId.ETHEREUM) {
                cutoff = 10;
                tokenName = 'Ethereum';
                return calculatedAmount < cutoff;
            }
            else if (asset.network == ChainId.SOLANA || asset.network == ChainId.SOLANA_DLN) {
                cutoff = 1;
                tokenName = 'Solana';
                return calculatedAmount < cutoff;
            }
            else {
                cutoff = 5;
                if (asset.network == ChainId.AVALANCHE) {
                    tokenName = 'Avalanche';
                }
                else if (asset.network == ChainId.POLYGON) {
                    tokenName = 'Matic';
                }
                else if (asset.network == ChainId.BSC) {
                    tokenName = 'BnB';
                }
                else {
                    tokenName = 'Ethereum';
                }
                return calculatedAmount < cutoff;
            }
        }
    })) {
        return {
            valid: false,
            error: "Orders using ".concat(tokenName, " must have atleast $").concat(cutoff, " reserved for gas fees."),
        };
    }
    return {
        valid: true,
        error: '',
    };
};
